<template>
  <div class="autumn-course-question-list">
    <img class="header-img"
         :src="require('@/pages/2020/SpringCourse/assets/img/question.png')"
         alt="常见问题"
    />
    <div class="question-list">
      <div class="question-item">
        <div class="question">Q: 是否有免费试听课？</div>
        <div class="answer">A: <a class="link" :href="replayUrl">点击这里</a>可以查看"过往课程直播回放片段"。</div>
      </div>
      <div class="question-item">
        <div class="question">Q: 孩子在哪里上课，是否有家长微信群？</div>
        <div class="answer">
          A: 通过电脑登录
          <span class="text-highlight">少年商学院官网（YouthMBA.com）</span>或在
          <span class="text-highlight">iPad下载“少年商学院”APP后登录上课</span>
          。正式开课前，班主任老师将会邀请家长/学员进入班级专属微信群。开课前会有提醒。
        </div>
      </div>
      <div class="question-item">
        <div class="question">Q: 错过直播课怎么办，是否可以回放？</div>
        <div class="answer">
          A：每次视频直播结束后次日早上7点开始，即可随时回放，永久无限次观看学习。
          回放学习过程有疑问可咨询班主任，课后完成创意实践挑战，APP提交作品仍然获得专业点评。
        </div>
      </div>
      <div class="question-item">
        <div class="question">Q: 课程主题工具包里有什么？</div>
        <div class="answer">
          A：工具包是帮助孩子完成课后挑战的辅助教材，
          其中包括上课说明、家长指导手册、课程专属内容手册和创意笔记本等。
        </div>
      </div>
      <div class="question-item">
        <div class="question">Q：购买春季直播课以后，在哪里查看所获积分？</div>
        <div class="answer">
          A：登录“少年商学院”APP，在“个人中心”页面左上角为“积分中心”，点击进入，可查看积分和积分规则。
        </div>
      </div>
      <div class="question-item"
           v-if="status === 'preference' || status === 'discount'"
      >
        <div class="question">Q：积分兑换的优惠券，可以怎么用？</div>
        <div class="answer">
          A：积分兑换的优惠券，可以在春季直播课特惠活动中叠加使用（10000积分可
          兑换100元优惠券）。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AutumnCourseProductList2019',
    props: {
      replayUrl: {
        type: String,
        required: true,
      },
      status: {
        type: String,
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .autumn-course-question-list {
    padding: 58px 60px 0 60px;
    box-sizing: border-box;
    background: @color-white;
  }

  .header-img {
    display: block;
    margin-left: 16px;
    margin-bottom: 50px;
    width: 344px;
    height: 72px;
  }

  .question-item {
    &:not(:last-child) {
      margin-bottom: @size-large;
    }
  }

  .question {
    margin-bottom: 15px;
    font-size: 26px;
    font-weight: @font-weight-bold;
    color: @color-text-base;
    line-height: 1.4;
  }
  .answer {
    font-size: 26px;
    color: @color-text-light;
    line-height: 1.6;
    .text-highlight {
      color: @color-text-base;
    }
    .link {
      color: #ff0000;
      padding-bottom: @size-extra-small / 2;
      border-bottom: 1px solid #ff0000;
    }
    .highlight {
      color: #ff0000;
    }
  }


</style>
